export { default } from "./blueHeaderContent";
